import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { useFormik } from "formik";
import { Button, Typography, TextField, Switch } from "@packages/ui";
import { Box, Grid, makeStyles, useMediaQuery, FormControl, Select, InputLabel, MenuItem, FormHelperText } from "@material-ui/core";
import InputMask from "react-input-mask";
import _ from "lodash";

import SnackBar from "../../layouts/SnackBar";
import * as authActions from "src/actions/authActions";
import * as virActions from "src/actions/virActions";

const useStyles = makeStyles((theme) => ({
    rowGroup: {
        display: "flex",
        flexDirection: "row",
        flexWrap: "wrap",
        justifyContent: "space-between"
    },

    textFieldFull: {
        width: "100%"
    },
    textFieldAlmostHalf: {
        width: "49%"
    },
}));
export default function VirContactForm({brand}) {
    const classes = useStyles();
    const dispatch = useDispatch();
    const virSendContact = useSelector((state) => state.vir.virSendContact);
    const urlParams = new URLSearchParams(window.location.search);
    const paramVirId = urlParams.get("virId") ? urlParams.get("virId") : "";
    const paramBookingRef = urlParams.get("bookingRef") ? urlParams.get("bookingRef") : "";
    const paramLastName = urlParams.get("lastName") ? urlParams.get("lastName") : "";
    const paramFirstName = urlParams.get("firstName") ? urlParams.get("firstName") : "";
    const paramEmail = urlParams.get("email") ? urlParams.get("email") : "";
    const paramContactNumber = urlParams.get("contactNumber") ? urlParams.get("contactNumber") : "";
    const isDesktop = useMediaQuery("@media screen and (min-width: 768px)");

    /* useEffect(() => {
        if (auth.success && _.isEmpty(rentals)) {
            dispatch(appActions.getRentals(auth));
        }
    }, [auth.success]); */

    const filterInputs = (formSubmitData) => {
        return Object.entries(formSubmitData).reduce((result, [key, value]) => {
            if (!value) {
                return result;
            }

            if (key === "dob") {
                value = value.replace(/ \/ /g, "");
            }

            if (key === "raNumber") {
                const valueString = value.toString()
                value = valueString.length == 9 ? valueString : (valueString + (valueString % 7));
            }

            result[key] = value.toString().trim();
            return result;
        }, {});
    };

    const formik = useFormik({
        initialValues: {
            bookingRef: paramBookingRef,
            virId: paramVirId,
            lastName: paramLastName,
            firstName: paramFirstName,
            email: paramEmail,
            contactNumber: paramContactNumber,
            brand,
            enquiryType: "",
            enquiryDetails: ""
        },
        onSubmit: (values) => {
            const { virId,
                bookingRef,
                firstName,
                lastName,
                email,
                contactNumber,
                brand,
                enquiryType,
                enquiryDetails
            } = values
            const rentalAgreementNumber = !_.isNil(bookingRef) 
                && bookingRef !== "" 
                &&  bookingRef[0].toUpperCase() === "B" ? null : bookingRef.toUpperCase() 
            const reservationNumber = !_.isNil(bookingRef) 
            && bookingRef !== "" 
            && (bookingRef[0].toUpperCase() === "B" || bookingRef[0] === "9") ? bookingRef.toUpperCase() : null
            dispatch(
                virActions.virSendContact({
                    virId,
                    rentalAgreementNumber,
                    reservationNumber,
                    firstName,
                    lastName,
                    email,
                    contactNumber,
                    brand: brand.toLowerCase(),
                    enquiryType,
                    enquiryDetails
                })
            );
        },
        validate: (values) => {
            const errors = {};
            if (!values.bookingRef && !values.virId) {
                errors.virId = "Please enter either VIR or booking ref#";
            }
            if (!values.lastName) {
                errors.lastName = "Required";
            }

            if (!values.firstName) {
                errors.firstName = "Required";
            }

            if (!values.email) {
                errors.email = "Required";
            }

            if (!values.enquiryType) {
                errors.enquiryType = "Required"
            }

            if (!values.enquiryDetails) {
                errors.enquiryDetails = "Required"
            }
            return errors;
        },
    });

    return (
        <React.Fragment>
            <SnackBar />
            <form onSubmit={formik.handleSubmit} style={{ textAlign: "left" }}>
                <div>
                    <Typography variant="h3">Reference</Typography>
                    <Typography variant="caption">Please provide either the vehicle incident report or booking reference</Typography>
                    <div className={classes.rowGroup}>
                        <TextField
                            name="virId"
                            label="Vehicle Incident Report #"
                            error={formik.errors.virId ? true : false}
                            helperText={formik.errors.virId ? formik.errors.virId : null}
                            onChange={formik.handleChange}
                            className={isDesktop ? classes.textFieldAlmostHalf : classes.textFieldFull}
                            value={formik.values.virId}
                            inputProps={{ type: "text" }}
                        />
                        <TextField

                            name="bookingRef"
                            label="Rental # or Reservation ID"
                            error={formik.errors.bookingRef ? true : false}
                            helperText={formik.errors.bookingRef ? formik.errors.bookingRef : null}
                            className={isDesktop ? classes.textFieldAlmostHalf : classes.textFieldFull}
                            onChange={formik.handleChange}
                            value={formik.values.bookingRef}
                            inputProps={{ type: "text" }}
                        />
                    </div>
                </div>

                <div>
                    <Typography variant="h3">Contact Information</Typography>
                    <div className={classes.rowGroup}>                        
                        <TextField
                            name="firstName"
                            label="First Name"
                            error={formik.errors.firstName ? true : false}
                            required
                            helperText={formik.errors.firstName ? formik.errors.firstName : null}
                            className={isDesktop ? classes.textFieldAlmostHalf : classes.textFieldFull}
                            onChange={formik.handleChange}
                            value={formik.values.firstName}
                            inputProps={{ type: "text" }}
                        />
                        <TextField
                            name="lastName"
                            label="Last Name"
                            error={formik.errors.lastName ? true : false}
                            required
                            helperText={formik.errors.lastName ? formik.errors.lastName : null}
                            className={isDesktop ? classes.textFieldAlmostHalf : classes.textFieldFull}
                            onChange={formik.handleChange}
                            value={formik.values.lastName}
                            inputProps={{ type: "text" }}
                        />
                        <TextField
                            name="email"
                            label="Email"
                            error={formik.errors.email ? true : false}
                            required
                            helperText={formik.errors.email ? formik.errors.email : null}
                            className={isDesktop ? classes.textFieldAlmostHalf : classes.textFieldFull}
                            onChange={formik.handleChange}
                            value={formik.values.email}
                            inputProps={{ type: "email" }}
                        />
                        <TextField

                            name="contactNumber"
                            label="Phone #"
                            error={formik.errors.contactNumber ? true : false}
                            helperText={formik.errors.contactNumber ? formik.errors.contactNumber : null}
                            className={isDesktop ? classes.textFieldAlmostHalf : classes.textFieldFull}
                            onChange={formik.handleChange}
                            value={formik.values.contactNumber}
                            inputProps={{ type: "tel" }}
                        />
                    </div>
                </div>
                <div>
                    <Typography variant="h3">Enquiry Details</Typography>
                    <Typography variant="caption">Please provide details of your enquiry ensuring that no personally identifiable information (PII) is included. This includes sensitive data such as driver’s licence numbers or credit card information.</Typography>
                    <div className={classes.rowGroup}>
                        <FormControl
                            variant="outlined"
                            className={[isDesktop ? classes.textFieldAlmostHalf : classes.textFieldFull, "MuiFormControl-marginNormal"]}
                        >
                            <InputLabel htmlFor="enquiryType">Enquiry Type</InputLabel>
                            <Select
                                native
                                required
                                error={formik.errors.enquiryType ? true : false}
                                helperText={formik.errors.enquiryType ? formik.errors.enquiryType : null}
                                value={formik.values.enquiryType}
                                onChange={formik.handleChange}
                                label="Enquiry Type"
                                inputProps={{
                                    name: 'enquiryType',
                                }}
                            >
                                <option aria-label="None" value="" ></option>
                                <option value="Request Update">Request Update</option>
                                <option value="Request Documents">Request Documents</option>
                                <option value="Dispute Damage">Dispute Damage</option>
                                <option value="Query Cleaning Charges">Query Cleaning Charges</option>
                                <option value="Query Rental Charges">Query Rental Charges</option>
                                <option value="Other">Other</option>
                            </Select>
                            <FormHelperText className="MuiFormHelperText-root Mui-error">{formik.errors.enquiryType ? formik.errors.enquiryType : ""}</FormHelperText>
                        </FormControl>
                        <TextField

                            name="enquiryDetails"
                            label="Enquiry Details"
                            required
                            error={formik.errors.enquiryDetails ? true : false}
                            helperText={formik.errors.enquiryDetails ? formik.errors.enquiryDetails : null}
                            className={classes.textFieldFull}
                            multiline
                            minRows={5}
                            onChange={formik.handleChange}
                            value={formik.values.enquiryDetails}
                            inputProps={{ type: "text" }}
                        />
                    </div>
                </div>


                <Box style={{ marginTop: 15 }}>
                    <Button fullWidth type="submit" loading={virSendContact.loading} title={"Send"} />
                </Box>
            </form>
        </React.Fragment>
    );
}